/**
 * @fileoverview Utilidades para gestión del LocalStorage
 * @description Funciones para limpiar y gestionar el LocalStorage de la aplicación
 */

import { sociedadStorage } from '../stores/sociedadStorage';
import { accionFormativaStorage } from '../stores/accionFormativaStorage';
import { cursoStorage } from '../stores/cursoStorage';
import { polizaStorage } from '../stores/polizaStorage';

/**
 * Limpia todo el LocalStorage relacionado con la aplicación
 */
export const clearAllStorage = (): void => {
  try {
    sociedadStorage.clearSociedad();
    sociedadStorage.clearTipoFormacion();
    accionFormativaStorage.clearAccionFormativa();
    cursoStorage.clearCurso();
    polizaStorage.clearPoliza();

  } catch (error) {
    return undefined;
  }
};

/**
 * Verifica si hay datos guardados en el LocalStorage
 * @returns true si hay al menos un dato guardado
 */
export const hasStoredData = (): boolean => {
  try {
    return (
      sociedadStorage.hasSociedad() ||
      accionFormativaStorage.hasAccionFormativa() ||
      cursoStorage.hasCurso() ||
      polizaStorage.hasPoliza()
    );
  } catch (error) {
    return false;
  }
};

